// extracted by mini-css-extract-plugin
module.exports = {"CouponExpired":"CountDownTip_CouponExpired__YnSAK"};